import React from 'react';
import SEO from './SEO';

function Digantha() {
    const apkFile = process.env.PUBLIC_URL + '/assets/Digantha-Apk 26-11.apk';
    const logoFile = process.env.PUBLIC_URL + '/assets/Digantha AR.png';

    return (
        <>
            <SEO
                title="Digantha - AR Android App · Vijay Kagupati"
                description="Digantha is an AR Android app delivering an immersive experience. Download the APK and explore."
                url="https://vijaypages.com/digantha"
            />
            <div className="digantha-page">
                <div className="digantha-container" data-aos="fade-up" data-aos-duration="1000">
                    {/* App Logo */}
                    <div className="digantha-logo">
                        <img src={logoFile} alt="Digantha AR Logo" />
                    </div>

                    {/* App Info */}
                    <div className="digantha-content">
                        <h1 className="digantha-title">Digantha</h1>
                        <p className="digantha-tagline">Your Next Immersive Experience</p>

                        <div className="digantha-details">
                            <div className="detail-item">
                                <span className="detail-icon">📱</span>
                                <span className="detail-text">Android App</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-icon">📦</span>
                                <span className="detail-text">APK Download</span>
                            </div>
                        </div>

                        {/* Download Button */}
                        <div className="cta-container">
                            <a href={apkFile} download="Digantha.apk">
                                <button className="cta-button digantha-download">
                                    <span className="download-icon">⬇️</span>
                                    Download APK
                                </button>
                            </a>
                        </div>

                        {/* Installation Instructions */}
                        <div className="install-instructions glass-panel">
                            <h3>📋 Installation Guide</h3>
                            <ol>
                                <li>Download the APK file</li>
                                <li>Enable "Install from Unknown Sources" in Settings</li>
                                <li>Open the downloaded file</li>
                                <li>Tap "Install" and enjoy!</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Digantha;
